import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";

export default function SosButton() {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [steps, setSteps] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (open) {
      api.get("/sos").then((r) => setSteps(r.data));
    }
  }, [open, lang]);

  useEffect(() => { if (!open) setCurrent(0); }, [open]);

  return (
    <>
      <button
        data-testid="sos-fab"
        onClick={() => setOpen(true)}
        className="fixed bottom-20 sm:bottom-6 right-6 sm:right-52 z-50 bg-[#E07A5F] text-white rounded-full shadow-2xl hover:bg-[#D56D52] transition-all hover:scale-105 pl-4 pr-5 py-3 flex items-center gap-2 font-medium"
        aria-label={t("sos.fab")}
      >
        <LifeBuoy className="w-5 h-5" />
        <span className="hidden sm:inline">{t("sos.fab")}</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-[#3D405B]/50 backdrop-blur-sm p-4 animate-fade-in-up"
          onClick={() => setOpen(false)}
          data-testid="sos-modal"
        >
          <div
            className="bg-white rounded-3xl max-w-lg w-full p-6 md:p-8 shadow-2xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-xs uppercase tracking-widest text-[#E07A5F] font-semibold">{t("sos.badge")}</div>
            <h2 className="font-heading text-3xl text-[#3D405B] mt-1">{t("sos.title")}</h2>
            <p className="text-[#8A8D91] mt-2 text-sm">{t("sos.subtitle")}</p>

            {steps[current] && (
              <div className="mt-6 bg-[#F4F1DE] rounded-2xl p-5 min-h-[140px] animate-fade-in-up" data-testid={`sos-step-${steps[current].id}`}>
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 rounded-full bg-[#3D405B] text-white font-heading text-sm grid place-items-center">{steps[current].id}</span>
                  <div className="font-heading text-xl text-[#3D405B]">{steps[current].title}</div>
                </div>
                <p className="mt-3 text-[#3D405B]/85 leading-relaxed">{steps[current].content}</p>
              </div>
            )}

            <div className="flex items-center justify-between mt-6">
              <div className="flex gap-1.5">
                {steps.map((_, i) => (
                  <span key={i} className={`h-2 rounded-full transition-all ${i === current ? "bg-[#E07A5F] w-6" : "bg-[#E8E6E1] w-2"}`} />
                ))}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setOpen(false)}
                  data-testid="sos-close"
                  className="text-sm text-[#8A8D91] px-4 py-2 rounded-full hover:text-[#3D405B]"
                >
                  {t("sos.close")}
                </button>
                {current < steps.length - 1 ? (
                  <button
                    onClick={() => setCurrent((c) => c + 1)}
                    data-testid="sos-next"
                    className="bg-[#3D405B] text-white rounded-full px-5 py-2 font-medium hover:bg-[#2f3147] transition-colors text-sm"
                  >
                    {t("sos.next")}
                  </button>
                ) : (
                  <Link
                    to="/breathe"
                    onClick={() => setOpen(false)}
                    data-testid="sos-to-breathe"
                    className="bg-[#81B29A] text-white rounded-full px-5 py-2 font-medium hover:bg-[#73A38B] transition-colors text-sm"
                  >
                    {t("sos.toBreathe")}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
